import { render, staticRenderFns } from "./deleteScheduleClassesStaff.vue?vue&type=template&id=1ad1abf1&scoped=true"
import script from "./deleteScheduleClassesStaff.vue?vue&type=script&lang=js"
export * from "./deleteScheduleClassesStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteScheduleClassesStaff.vue?vue&type=style&index=0&id=1ad1abf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1abf1",
  null
  
)

export default component.exports